import { Input } from '@material-ui/core'
import styled from 'styled-components'
import { Flex } from 'components/common/styles'
import {
  GRAY2,
  PURPLE,
  PURPLE_RGB,
  TERTIARY_TEXT,
  BACKGROUND_REDESIGN,
} from 'constants/colors'

type StyledSearchProps = {
  value: string
}

export const StyledSearch = styled(Flex)`
  position: relative;

  svg {
    position: absolute;
    left: 9px;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0.65;
    z-index: 1;
  }
`

export const StyledSearchIcon = styled.div`
  padding: 6px 8px 7px;
  border: 1px solid ${GRAY2};
  border-radius: 8px;
  cursor: pointer;
`

export const StyledCloseIcon = styled.div`
  position: absolute;
  width: 18px;
  height: 18px;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;

  &:before,
  &:after {
    position: absolute;
    content: '';
    background: ${TERTIARY_TEXT};
    height: 2px;
    left: 2px;
    right: 2px;
    top: 50%;
  }

  &:before {
    transform: translateY(-50%) rotateZ(-45deg);
  }

  &:after {
    transform: translateY(-50%) rotateZ(45deg);
  }
`

export const StyledSearchInput = styled(Input)<StyledSearchProps>`
  input {
    padding: 7px 12px 8px 38px;
    width: 220px;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid ${GRAY2};
    border-radius: 8px;
    transition: 0.3s;
    ${({ value }) => value && { background: BACKGROUND_REDESIGN }}

    &:focus {
      border-color: ${PURPLE};
      box-shadow: 0 0 2px 4px rgba(${PURPLE_RGB}, 0.3);
      background: transparent;
    }
  }
`
